import { CsvColumn } from '../../types/CsvTemplate'

export interface CsvTemplateMetadata {
	success: boolean
	template: CsvColumn[]
	maxRowsPerUpload: number
}

/**
 * Fetch training users CSV template metadata from backend.
 * Includes field descriptions and constraints for display to users.
 */
export async function getTrainingUsersTemplateMetadata(): Promise<CsvTemplateMetadata> {
	const response = await fetch(
		`${process.env.REACT_APP_BASE_API}/admin/training-sessions/users-csv-template-metadata`,
		{
			method: 'GET',
			headers: {
				'Content-Type': 'application/json',
			},
			credentials: 'include',
		}
	)

	if (!response.ok) {
		throw new Error(`Failed to fetch CSV template metadata: ${response.statusText}`)
	}

	return response.json()
}
